<template>
  <div class="404-page page-error">
    <EmptyState
      :confirm-action="redirect"
      illustration="404"
      title="Ops! A página que você procura não foi encontrada!"
      subtitle="A página que você tentou acessar não existe mais. Mas não se preocupe, para continuar navegando você pode voltar para o início e fazer um outro caminho dentro da plataforma."
      confirm-action-text="Voltar para o início"
    />
  </div>
</template>

<script>
import EmptyState from '@/components/harvest/ui/emptyState/EmptyState.vue';
export default {
  components: {
    EmptyState
  },
  methods: {
    redirect() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.page-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 80px);
  text-align: center;
}
</style>
